import flattenCategories from '@utils/formatters/flatten-categories';
import { selectFlatCategories } from 'containers/AppContainer/selectors';
import type { SingleCategory } from 'lib/sdks/search';
import { searchCategories } from 'lib/sdks/search';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useCategoryLookup = (categoryId?: number) => {
  const reduxCategories = useSelector(selectFlatCategories);

  const [categories, setFetchedCategories] =
    useState<SingleCategory[]>(reduxCategories);

  useEffect(() => {
    if (categories.length) {
      return;
    }

    const fetchCategories = async () => {
      const cats = flattenCategories(await searchCategories(false));
      setFetchedCategories(cats);
    };

    fetchCategories();
  }, [categories]);

  return categoryId ? categories.find(cat => cat.id === categoryId) : undefined;
};
